import { Component, HostListener, OnInit } from '@angular/core';
import { NoteService } from '../../services/note.service';
import { NavigationHelper } from '../../helpers/navigation';
import { PottyNotesConstants } from '../../potty-notes-consts';
import { PottyNotesGestureController } from '../../utils/gesture.controller';
import { Router } from '@angular/router';

@Component({
    selector: 'add-thoughts-container',
    templateUrl: 'add-thoughts.html',
    styleUrls: ['add-thoughts.scss'],
    standalone: false
})
export class AddThoughtsContainer implements OnInit {
	public static readonly ComponentIdentifier: number = 4;
	public activeStep = 5;
	public isStartOfFlow: boolean;
	public thoughts = '';
	public nextButtonText: string;
	public textAreaPlaceholder: string;
	public maxThoughtsLength = 500;

	private initialTouchX: number | null = null;
	private initialTouchY: number | null = null;
	private touchStartTime: number | null = null;

	constructor(
		private noteService: NoteService,
		private navigationHelper: NavigationHelper,
		private router: Router) { }

	ngOnInit(): void {
		this.isStartOfFlow = this.navigationHelper.isStartOfNoteFlow();
		this.textAreaPlaceholder = PottyNotesConstants.placeholderInputs[Math.floor(Math.random() * PottyNotesConstants.placeholderInputs.length)]

		if (this.noteService.thoughts == null || this.noteService.thoughts == '') {
			this.nextButtonText = 'skip';
			this.thoughts = '';
		}
		else {
			this.nextButtonText = 'next';
			this.thoughts = this.noteService.thoughts;
		}
	}

	public saveThoughtsMetadata(event: Event) {
		const wasSkipped = this.navigationHelper.skipButtonPressed(event) || this.thoughts.trim() == '';
		this.noteService.thoughts = this.thoughts;
		this.noteService.setThoughts(this.thoughts, wasSkipped);
	}

	public onThoughtsChange(event: any): void {
		this.nextButtonText = this.thoughts.trim() == '' ? 'skip' : 'next';
	}

	// Gesture control 
	@HostListener('touchstart', ['$event'])
	public onTouchStart(event: TouchEvent): void {
		event.stopPropagation();
		this.initialTouchX = event.touches[0].clientX;
		this.initialTouchY = event.touches[0].clientY;
		this.touchStartTime = Date.now();
	}

	@HostListener('touchmove', ['$event'])
	public onTouchMove(event: TouchEvent): void {
		event.stopPropagation();

		if (this.initialTouchX === null || this.touchStartTime === null || this.initialTouchY == null) return;

		const currentTouchX = event.touches[0].clientX;
		const currentTouchY = event.touches[0].clientY;
		const deltaX = currentTouchX - this.initialTouchX;
		const deltaY = currentTouchY - this.initialTouchY;
		const timeDiff = Date.now() - this.touchStartTime

		// This represents moving backward in the add notes flow.
		if (PottyNotesGestureController.MovedRightEnough(timeDiff, deltaX, deltaY)) {
			this.saveThoughtsMetadata(event);
			this.router.navigate([`${this.navigationHelper.getPreviousComponentUrl()}`]);
		}
		// Otherwise, forward.
		else if (PottyNotesGestureController.MovedLeftEnough(timeDiff, deltaX, deltaY)) {
			this.saveThoughtsMetadata(event);
			this.router.navigate([`${this.navigationHelper.getNextComponentUrl()}`]);
		}
	}

	@HostListener('touchend', ['$event'])
	public onTouchEnd(event: TouchEvent): void {
		event.stopPropagation();
	}
}
